export default __webpack_public_path__ + "static/Akhil_Vishva_Parisad-5e15d7e713633f953ae8b072e239c201.png";